export default "__VITE_ASSET__Tlpgt3a8__"